module.exports = {"621126100":"岷阳镇","621126101":"蒲麻镇","621126102":"西寨镇","621126103":"梅川镇","621126104":"西江镇","621126105":"闾井镇","621126106":"十里镇","621126107":"茶埠镇","621126108":"中寨镇","621126200":"清水乡","621126201":"马坞乡","621126202":"寺沟乡","621126203":"麻子川乡","621126204":"秦许乡","621126205":"禾驮乡","621126206":"维新乡","621126207":"申都乡","621126208":"锁龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621126.json
// module id = 2740
// module chunks = 0